import { render, staticRenderFns } from "./updateInvoice.vue?vue&type=template&id=205b8174&scoped=true&"
import script from "./updateInvoice.vue?vue&type=script&lang=js&"
export * from "./updateInvoice.vue?vue&type=script&lang=js&"
import style0 from "./updateInvoice.vue?vue&type=style&index=0&id=205b8174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b8174",
  null
  
)

export default component.exports